<template>
    <div
        class="role-name-input"
        :class="clazz"
        @submit="preventSubmit"
    >
        <v-form
            ref="roleNameform"
            kind="desc"
            @submit="onSubmit"
        >
            <v-form-item
                v-model="errMsg"
                name="ruleName"
                error-placement="top-right"
                :label="$t('规则名称')"
                :rules="ruleArr"
                :required="$t('请输入规则名称')"
            >
                <v-input
                    v-model="ruleName"
                    name="ruleName"
                    :placeholder="$t('请输入规则名')"
                    :limit="10"
                    autofocus
                    @input="ruleNameInput"
                />
            </v-form-item>
        </v-form>
    </div>
</template>
<script>
export default {
  model: {
    prop: 'val',
    event: 'input',
  },
  props: {
    clazz: {
      type: String,
      default: '',
    },
    val: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ruleName: this.val,
      errMsg: '',
      ruleArr: [
        { required: true, message: this.$t('请输入规则名称'), trim: true },
        { maxLength: 10, message: this.$t('规则名称字数超限'), trim: true, custom: true },
      ],
    };
  },

  watch: {
    val(v) {
      this.ruleName = v;
    },
  },

  created() {
    this.ruleName = this.val;
  },

  methods: {
    ruleNameInput(val) {
      this.$emit('input', val);
    },

    preventSubmit(e) {
      e.preventDefault();
    },

    getErrMsg() {
      if (this.errMsg) {
        this.$refs.roleNameform.focusError();
      }
      return this.errMsg;
    },

    formSubmit() {
      this.$refs.roleNameform.submit();
    },

    onSubmit(e) {
      this.$emit('submit', e);
    },
  },
};
</script>
